export function TheCloserIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="12" y="12" width="24" height="28" rx="3" />
      <line x1="12" y1="20" x2="36" y2="20" />
      <line x1="20" y1="12" x2="20" y2="16" />
      <line x1="28" y1="12" x2="28" y2="16" />
      <line x1="18" y1="32" x2="30" y2="32" />
      <circle cx="24" cy="32" r="1.5" fill="currentColor" />
    </svg>
  );
}
